export const type = 'div';
export const isDiv = node => node.type === type;
